const headers = h => h.map(d => ({
    ...{
        align: 'start',
        class: 'primary white--text',
        sortable: false
    },
    ...d,
}));

export { headers };